import { render, staticRenderFns } from "./KartaBoryMall.vue?vue&type=template&id=6b608c82"
import script from "./KartaBoryMall.vue?vue&type=script&lang=js"
export * from "./KartaBoryMall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports